import Banner from "@/components/landing/reviews/Banner";
import Comunity from "@/components/landing/reviews/Comunity";
import Testimonials from "@/components/landing/reviews/Testimonials";

export default function Reviews() {
  return (
    <>
      {/* Banner section */}
      <Banner />

      {/* Testimonials section */}
      <Testimonials />

      {/* Comunity section */}
      <Comunity />
    </>
  );
}
